export const getXsrfToken = () => {
	return document.cookie
		.split('; ')
		.find(row => row.startsWith(`XSRF-TOKEN=SCORE.`))
		?.split('=')[1]
}

export const storeSASIDtoUrl = sasid => {
	const urlParams = new URLSearchParams(window.location.search)
	const urlSASID = urlParams.get('SASID')

	if (!sasid || !window || (window === window.top && !urlSASID)) {
		return
	}

	urlParams.set('SASID', sasid)

	const search = urlParams.toString()
	const newURL = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash || ''}`

	window.history.replaceState(window.history.state, '', newURL)
}
